import { Component, OnInit, Input, Output, EventEmitter, OnChanges } from '@angular/core';

@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss']
})
export class PaginationComponent implements OnInit, OnChanges {

  @Input() totalItems: number;
  @Input() itemsPerPage: number;
  @Output() onPrevSelected: EventEmitter<any>;
  @Output() onNextSelected: EventEmitter<any>;
  totalPages: number = 0;
  selectedItemPerPage: number = 20;
  pageNumber: number = 0;
  lastPage: number = 0;
  constructor() {
    this.onPrevSelected = new EventEmitter<any>();
    this.onNextSelected = new EventEmitter<any>();
  }

  ngOnInit(): void {
    this.totalPages = Math.ceil(this.totalItems / this.selectedItemPerPage);
  }

  prev() {
    if (this.pageNumber >= 1) {
      if (this.pageNumber != 0) {
        this.pageNumber -= 1;
      }
      this.onPrevSelected.emit(this.pageNumber);
    }
  }

  next() {
    this.lastPage = Math.ceil(this.totalItems / this.selectedItemPerPage) - 1;
    if (this.pageNumber <= this.lastPage) {
      if (this.pageNumber != this.lastPage) {
        this.pageNumber += 1;
      }
      this.onNextSelected.emit(this.pageNumber);
    }
  }

  ngOnChanges(value: any) {
    if (value.totalItems) {
      this.totalItems = value.totalItems.currentValue;
    }
    if (value.itemsPerPage) {
      this.selectedItemPerPage = value.itemsPerPage.currentValue;
    }
    this.pageNumber = 0;
    this.totalPages = Math.ceil(this.totalItems / this.selectedItemPerPage);
  }
}
